// Misc
import { createElement } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import { Link as RouterLink } from 'react-router-dom'

// Styles
// @todo
const styles = {
  root: {
    color: 'inherit',
    textDecoration: 'none',
  }
}

const Link = ({ external, to, className, classes, ...rest }) => {
  let element
  let props

  if (external) {
    element = 'a'
    props = { href: to, ...rest, target: '_blank' }
  } else {
    element = RouterLink
    props = { to, ...rest }
  }

  return createElement(element, {
    ...props,
    className: classNames(className, classes.root)
  })
}

Link.propTypes = {
  external: PropTypes.bool,
  to: PropTypes.any,
  classes: PropTypes.object.isRequired,
  className: PropTypes.any,
}

export default withStyles(styles)(Link)
